function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M70.16 35.9l-33.6 11.9-20-10.72a8.6 8.6 0 00-6.57-.38l-6 2.53 13 16c9.57 11.47 23.74 15.81 37.85 10.89l84.74-30.2a26.18 26.18 0 0016.72-18.13 26.18 26.18 0 00-24.34-3.77L98.6 25.84"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76.26 42.06L42.56 7.82l9.39-3.27a10 10 0 017.75.51l48.36 25.85M12.06 108.37h136.35"
});

var SvgRoaming = function SvgRoaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160.32 112.37",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgRoaming;